module.exports = __webpack_public_path__ + "media/components/src/assets/images/store-image/lawson-ff6170bd5d88662a31795923ae28195f.png";